export default {
    COLOR: {
        CHART_PIE_MEMBACA: ['#61EC8F', '#03C46B', '#02A76B', '#38DB7E',],
        CHART_PIE_MATEMATIKA: ['#60DDF1', '#0097CE', '#0175B2', '#0175B2'],
        CHART_PIE_SAINS: ['#FFDE6A', '#FEBC04', '#DB9C03', '#FFD143'],
        CHART_LINE_LITERASI: ["#03C46B", "#FEBC04", "#0097CE"],
        RED: '#FF3838',
        GREEN: '#03C46B',
        BLUE: '#0097CE',
        YELOW: '#FEBC04',
    },
    LABEL: {
        LITERASI_MEMBACA: 'LITERASI MEMBACA',
        LITERASI_MATEMATIKA: 'LITERASI MATEMATIKA',
        LITERASI_SAINS: 'LITERASI SAINS',
        LITERASI: ['Membaca', 'Matematika', 'Sains'],
        LITERASI_EKONOMI: [
            "Membaca",
            "Matematika",
            "Sains",
            "Membaca",
            "Matematika",
            "Sains",
            "Membaca",
            "Matematika",
            "Sains"
        ],
        LITERASI_GENDER: [
            "Membaca",
            "Matematika",
            "Sains",
            "Membaca",
            "Matematika",
            "Sains",
        ],
        CHART_BAR_HASIL_SK: [
            "Beriman",
            "Gotong royong",
            "Berkhebinekaan",
            "Mandiri",
            "Kritis",
            "Kreatif",
        ],
    }

}